module.exports = __webpack_public_path__ + "static/media/Piercing-microdermal-cheekbone.44bdb96d.png";